export default __webpack_public_path__ + "fa7fb01edf8d0521d7b54884d6f659b9.png";